
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Component, Vue } from "vue-property-decorator";
import NR, { CV, Ats } from "@/lib//model/NRXQ/nr";
import Auth from "@/lib/common/auth";
import vuexStore from "@/store/vuex-store";
import AtsTable from "@/views/nr/components/ats-manager-table.vue";
import Model from "@/lib/model/model";

class FormData extends Model {
  name = "";
  isClose = 2; //默认 开启
}

@Component({
  components: { AtsTable }
})
export default class CustomList extends Vue {
  nrToken = "";
  data: any = {}; //表格所有数据
  tableData: any[] = []; //表格list数据
  page = 1;
  pageSize = 10;
  companyId = "";
  search = { name: "", status: 0 };
  showAdd = false;
  formData = new FormData();
  isEdit = false;
  atsCompanyId = "";

  rules = {
    name: [{ required: true, message: "请输入客户名称", trigger: "blur" }]
  };

  created() {
    this.nrToken = String(localStorage.getItem("nrToken") || "");
    this.companyId = Auth.companyId;
    this.getList();
  }
  mounted() {
    //
  }
  async getList() {
    await Ats.getAtsCompanyList({
      page: this.page,
      pageSize: this.pageSize,
      companyId: this.companyId
    }).then(res => {
      this.data = res;
      this.tableData = this.data.list;
    });
  }
  async submit() {
    (this.$refs["form"] as any)?.validate(async (valid: any) => {
      if (valid) {
        let p: any = {};
        p = this.formData;
        p.companyId = this.companyId;
        if (!this.isEdit) {
          await Ats.createAtsCompany(p);
        } else {
          p.atsCompanyId = this.atsCompanyId;
          await Ats.updateAtsCompany(p);
        }
        this.$message.success("保存成功");
        this.close();
        this.getList();
      }
    });
  }

  //新增
  add() {
    this.formData = new FormData();
    this.isEdit = false;
    this.open();
  }
  //编辑
  edit(row: any) {
    this.atsCompanyId = row.atsCompanyId;
    this.formData.assign(row);
    console.log(this.formData);
    this.isEdit = true;
    this.open();
  }
  //查看
  showDetail(row: any) {
    this.atsCompanyId = row.atsCompanyId;
    this.$router.push("/ats-detail?atsCompanyId=" + this.atsCompanyId);
  }
  open() {
    this.showAdd = true;
  }
  close() {
    this.showAdd = false;
  }
}
